import { render, staticRenderFns } from "./DeviceInfo.vue?vue&type=template&id=bc9dc5ae&scoped=true&"
import script from "./DeviceInfo.vue?vue&type=script&lang=js&"
export * from "./DeviceInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc9dc5ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc9dc5ae')) {
      api.createRecord('bc9dc5ae', component.options)
    } else {
      api.reload('bc9dc5ae', component.options)
    }
    module.hot.accept("./DeviceInfo.vue?vue&type=template&id=bc9dc5ae&scoped=true&", function () {
      api.rerender('bc9dc5ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/devices/devicedetail/deviceinfo/DeviceInfo.vue"
export default component.exports